import React, { useEffect, useState } from 'react';

export type UseIsOnScreen = (
  ref: React.RefObject<HTMLElement>,
  options?: { persistOnceSeen?: boolean } & ConstructorParameters<typeof IntersectionObserver>['1']
) => boolean;

export const useIsOnScreen: UseIsOnScreen = (ref, options = {}) => {
  const { persistOnceSeen = false, ...observerOptions } = options;
  const [isOnScreen, setIsOnScreen] = useState(false);

  const handleObserverChange: ConstructorParameters<typeof IntersectionObserver>['0'] = (entries, observer) => {
    const isIntersecting = entries.some(e => e.isIntersecting);
    if (!persistOnceSeen) return setIsOnScreen(isIntersecting);
    if (isIntersecting) {
      setIsOnScreen(true);
      observer.unobserve(entries[0]?.target);
    }
  };

  useEffect(() => {
    if (!ref.current) {
      return setIsOnScreen(true);
    }
    const observer = new IntersectionObserver(handleObserverChange, { threshold: 0.25, ...observerOptions });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return isOnScreen;
};
